import React from 'react'
import { useTranslation } from 'react-i18next';
import { classNames } from "primereact/utils";
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';


export const DeductionsInput = (props) => {
    const { formik, originalDeductions, toggleDeductionNumber, selectedData, setToggleDeductionNumber, setOriginalDeductions,
        deductionError, setDeductionError, error, getBillingPeriodMax, defMembership, min, max, initialTier, getFormErrorMessage, deductions, isFormFieldValid } = props
    const { t } = useTranslation("common");

    const businessPurpose = defMembership?.business.purpose;


    const deductionMaxError = () => {
        if (businessPurpose === "SERVICES") {
            return <span className="inv_deduction_errors">{t("products.deduction_error_payments_max", { max })}</span>
        } else return <span className="inv_deduction_errors">{t("products.deduction_error_donations_max", { max })}</span>
    }

    const deductionMinError = (period) => {
        if (period === "onChange") {
            return null;
        } else {
            if (businessPurpose === "SERVICES") {
                return <span className="inv_deduction_errors">{t("products.deduction_error_payments_min", { min })}</span>
            } else {
                return <span className="inv_deduction_errors">{t("products.deduction_error_donations_min", { min })}</span>
            }
        }
    }

    return (
        <div>
            <div className="labels">
                {businessPurpose === "SERVICES" ? <p className="deduction_title" >{t("plan.num_payments")}</p> :
                    <p className="deduction_title" >{t("plan.num_donations")}</p>}
            </div>
            <InputNumber
                id="deductions invite-deduc"
                name="deductions"
                style={{ height: "3rem", width: "100%" }}
                value={formik.values.deductions}
                disabled={!toggleDeductionNumber || selectedData()?.data.billingPeriod === "ONCE" || initialTier?.data?.billingPeriod === "ONCE"}
                keyfilter="int"
                placeholder={(toggleDeductionNumber === true ? "" : deductions())}
                className={classNames({
                    "p-invalid": isFormFieldValid("deductions"),
                })}
                pt={{
                    input: {
                        root: {
                            autocomplete: 'off'
                        }
                    }
                }}
                onChange={(e) => {
                    const value = Number(e.value);
                    formik.setTouched({ ...formik.touched, deductions: true });
                    formik.setFieldValue("deductions", value).then(() => {
                        formik.setFieldError("deductions", "");
                    });
                    const billing_period = selectedData()?.data?.billingPeriod
                        || initialTier?.data?.billingPeriod;


                    const min = 2;
                    const max = getBillingPeriodMax();

                    let error = null;
                    if (value === null || value === "") {
                        error = null;
                    } else if (billing_period === "ONCE") {
                        error = null;
                        if (value > max) {
                            error = deductionMaxError();
                        }
                    } else if (value < min) {
                        error = deductionMinError(billing_period);
                    } else if (value > max) {
                        error = deductionMaxError();
                    }

                    formik.setFieldError("deductions", error);
                    setDeductionError(error);
                }}

                onBlur={() => {
                    const value = selectedData()?.data?.deductions || initialTier?.data?.billingPeriod

                    if (value === null || value === "" || !value) {
                        formik.setFieldError("deductions", null);
                        return;
                    }

                    const min = 2;
                    const max = getBillingPeriodMax();

                    if (selectedData()?.data.billingPeriod !== "ONCE" && value < min) {
                        formik.setFieldError("deductions", deductionMinError(selectedData()?.data.deductions));
                    } else if (value > max) {
                        formik.setFieldError("deductions", deductionMaxError());
                    } else {
                        formik.setFieldError("deductions", null);
                    }
                    formik.setFieldError("deductions", error);
                    setDeductionError(error);
                }}
            />

            {deductionError ? (
                <div className="error-deduct p-error invitation_errors">
                    {deductionError}
                </div>
            ) : <div className="error-deduct p-error invitation_errors">{getFormErrorMessage("deductions")}</div>}

            <div className="main_div_input_switch">
                <div>
                    <InputSwitch
                        id="toggleDeductionNumber"
                        name="toggleDeductionNumber"
                        checked={toggleDeductionNumber}
                        disabled={initialTier?.data.billingPeriod === "ONCE" || selectedData()?.data.billingPeriod === "ONCE"}
                        onChange={(e) => {
                            setToggleDeductionNumber(e.value);
                            if (!e.value) {
                                setOriginalDeductions(formik.values.deductions);
                                formik.setFieldValue("deductions", "").then(() => {
                                    formik.setFieldError("deductions", "");
                                });
                            } else {
                                formik.setFieldValue("deductions", originalDeductions).then(() => {
                                    formik.validateField("deductions");
                                });
                            }
                        }}
                    />
                </div>
                <div>
                    {toggleDeductionNumber ? <span id="toggled">{t("invitation.override_text")}</span> :
                        <span id="untoggled">{t("invitation.override_text")}</span>}
                </div>
            </div>
        </div>
    )
}
